export const PRODUCTS = [
  {
    slug: "gin-and-marmalade",
    lookupKey: "scent_gin_marmalade",
    name: "Gin and Marmalade",
    tag: "Crisp Citrus",
    description: "Dry juniper botanicals with sweet Sevilla citrus peel.",
    price: 68,
    image:
      "https://images.unsplash.com/photo-1647943746660-1640133068d5?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    imageAlt: "Amber apothecary bottle in warm light on a pale surface",
  },
  {
    slug: "rosso",
    lookupKey: "scent_rosso",
    name: "Rosso",
    tag: "Sensual Warmth",
    description: "Rich dark berries, spiced petals, and magnetic resin.",
    price: 68,
    image:
      "https://images.unsplash.com/photo-1647943746352-a700b8a69da0?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    imageAlt: "Amber apothecary bottles in deep moody window light",
  },
  {
    slug: "jazz-club",
    lookupKey: "scent_jazz_club",
    name: "Jazz Club",
    tag: "Intimate Wood",
    description: "Smooth cured tobacco leaves and aged bourbon woods.",
    price: 68,
    image:
      "https://images.unsplash.com/photo-1647943746199-859ec463a24e?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    imageAlt: "Two amber apothecary bottles in low evening light",
  },
  {
    slug: "forest-essence",
    lookupKey: "scent_forest_essence",
    name: "Forest Essence",
    tag: "Earth & Pine",
    description: "Crisp pine needles, deep balsam, and wet cedar soil.",
    price: 68,
    image:
      "https://images.unsplash.com/photo-1608571899712-2109dac47629?fm=jpg&q=80&w=1200&auto=format&fit=crop",
    imageAlt: "Clear apothecary dropper bottle on pale marble",
  },
];

export const HERO_IMAGE = "/label.png";

export const FORMULA_IMAGE =
  "https://images.unsplash.com/photo-1723540634462-528708cc17aa?fm=jpg&q=80&w=2000&auto=format&fit=crop";
